import {navigationConstants} from "@data/constants/navigationConstants";

const initialState = {
    congrats: [],
    nextScreenParams: {}
}

export default function navigation(state = initialState, action) {
    switch (action.type) {
        case navigationConstants.PUT_CONGRATS:
            return {
                ...state,
                congrats: action?.data
            }
        case navigationConstants.PULL_NEXT_CONGRATS:
            let congratsCopy = state?.congrats?.slice()
            congratsCopy.shift()

            return {
                ...state,
                congrats: congratsCopy
            }
        case navigationConstants.PUT_NEXT_SCREEN_PARAMS:
            return {
                ...state,
                nextScreenParams: action?.data
            }
        case navigationConstants.PULL_NEXT_SCREEN_PARAMS:
            return {
                ...state,
                nextScreenParams: {}
            }

        default:
            return state
    }
}
